import { Modal, ModalId } from "../../../ui"
import { DataType, TableName } from "../../../../tables"
import { useActions } from "./actions"

type Props = {
    tableName: TableName
    dataType?: DataType
    directAction?: boolean
    onSubmit?: () => void
}

export const ArchiveModal = (props: Props) => {
    const { tableName, dataType, directAction, onSubmit } = props

    const { archiveDataType } = useActions()

    const renderBody = () => dataType ? <>
        {!directAction && 'El registro no se puede eliminar porque tiene referencias en registros de otra tabla. '}
        Desea <b>archivar</b> el registro? Esta acción hará que no aparezca en búsquedas y listados.
    </> : <></>
    
    const handleSubmit = () => onSubmit ? onSubmit() : archiveDataType(tableName, dataType!.id)
    
    return (
        <Modal
            modalId={directAction ? ModalId.DIRECT_ARCHIVE : ModalId.ARCHIVE}
            title="Archivar Registro?"
            submitLabel="Archivar"
            submitKind="secondary"
            onSubmit={handleSubmit}
        >
            {renderBody()}
        </Modal>
    )
}
